import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import coursesData from "../data/coursesData.json"; 

const CoursesSection = ({ isHomePage = false }) => {
  const navigate = useNavigate();

  const courses = coursesData.courses;
  const coursesByCategory = coursesData.categories;

  const [activeTab, setActiveTab] = useState(coursesByCategory[0].category);

  const activeCategory = coursesByCategory.find(
    (cat) => cat.category === activeTab
  );

  const activeCourses = activeCategory.itemIds
    .map((id) => courses.find((c) => c.id === id))
    .filter(Boolean);

  const coursesToShow = isHomePage ? activeCourses.slice(0, 5) : activeCourses;

  return (
    <section className="py-16 bg-[#f8f8f8] px-4 md:px-12">
      <div className="text-center mb-12">
        <p className="uppercase text-sm md:text-base text-gray-600 mb-4 font-bold tracking-widest">
          Our Courses
        </p>
        <h2 className="font-bold text-2xl md:text-5xl text-gray-700">
          {isHomePage ? "Explore Our Popular Courses" : "Learn & Upskill with Our Courses"}
        </h2>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap justify-center gap-3 mb-10">
        {coursesByCategory.map((cat) => (
          <button
            key={cat.category}
            onClick={() => setActiveTab(cat.category)}
            className={`px-5 py-2 rounded-full font-semibold transition-all duration-300 ${
              activeTab === cat.category
                ? "bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-md"
                : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-100"
            }`}
          >
            {cat.category}
          </button>
        ))}
      </div>

      {/* Courses Grid */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {coursesToShow.map((course) => (
          <div
            key={course.id}
            className="bg-white rounded-xl shadow-md hover:shadow-lg flex flex-col transition-all duration-300 overflow-hidden"
          >
            <img
              src={course.image}
              alt={course.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-5 flex flex-col flex-grow text-start">
              <h4 className="text-lg font-semibold text-gray-800 mb-3">
                {course.title}
              </h4>
              <p className="text-gray-600 text-sm mb-4 flex-grow">
                {course.description}
              </p>
              <button
                onClick={() => {
                  navigate(`/courses/${course.id}`);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="mt-auto bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold px-5 py-2 rounded-full self-start"
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* View All Button */}
      {isHomePage && (
        <div className="text-center mt-16">
          <button
            onClick={() => {
              navigate("/courses");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold px-8 py-3 rounded-full"
          >
            View All Courses
          </button>
        </div>
      )}
    </section>
  );
};

export default CoursesSection;
